(function TripSummaryComponentFilter($, Adzuki)
{
	'use strict';

	const component = {
		emits: [
			'addKeyword',
			'addTag',
			'removeKeyword',
			'removeTag',
			'resetFilter',
			'selectedTypes',
		],
		inject  : ['getFaIconStyle'],
		template: '#ts-component-filter',
		props   : {
			componentTypes: {
				type   : Array,
				default: [],
			},
			keywords: {
				type   : Array,
				default: [],
			},
			populated: {
				type   : Boolean,
				default: false,
			},
			tags: {
				type   : Array,
				default: [],
			},
		},
		data() {
			return {
				currentKeyword: '',
				selectedTypes : [],
			};
		},
		methods: {
			addKeyword() {
				if (this.currentKeyword.trim() === '') {
					return;
				}

				this.$emit('addKeyword', this.currentKeyword.trim());

				this.currentKeyword = '';
			},
			addTag(tag) {
				this.$emit('addTag', tag);
			},
			emitTypes() {
				this.$emit('selectedTypes', this.selectedTypes);
			},
			removeTag(tag) {
				this.$emit('removeTag', tag);
			},
			removeKeyword(keyword) {
				this.$emit('removeKeyword', keyword);
			},
			reset() {
				this.currentKeyword = '';
				this.selectedTypes  = [];

				this.$emit('resetFilter');
			},
		},
		watch: {
			selectedTypes: {
				handler() {
					this.emitTypes();
				},
				deep: true,
			},
		},
		mounted() {
			// init tags typeahead
			Adzuki.Typeahead(
				this.$refs.tags_search,
				async(term, display, $self) => {
					let url = '/TripSummaryTags/search/' + term + '/0';

					const response = await Adzuki.Ajax.get(url);

					$self.removeClass('ajax-spinner');

					display(response);
				},
				(tag, $self) => {
					this.addTag(tag);
					$self.val('');
				}
			);
		},
	};

	Adzuki.VueComponents.TripSummaryComponentFilter = component;
}(jQuery, window.Adzuki || {}));
